module.exports = __webpack_public_path__ + "img/csr-sb1-3.054a5898.jpg";